import React from 'react';

import Button from '../components/Button';

export default class IndexPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: ''
    };
  }

  _onLogoutButtonClick() {
    const { that } = this.props;
    localStorage.clear();
    let path = '/login';
    that.props.router.push({
      pathname : path
    });
  }

  _onButtonClick() {
    const { that, text } = this.props;

    if ('/'+text.toLowerCase() == that.props.location.pathname)
      return ;

    that.setState({
      currentPage : text.toLowerCase(),
    });

    let path = '/'+text.toLowerCase();
    that.props.router.push({
      pathname : path
    });
  }

  _renderButton(pageName, index) {
    let color = 'btn-default';
    if( pageName.toLowerCase() == this.state.currentPage ){
      color = 'btn-danger';
    }

    return (
        <Button
          that={this}
          key={index}
          text={pageName}
          color={color}
          onClick={this._onButtonClick}
        />
    )
  }

  render() {

    let pageList = ["Dashboard", "Sports", "Sportunities", "Circles", "Users", "Chats", "Venues", "Lockers"];
    return (
      <div className="container">
        <div style={{marginTop:20}}>
          {
            pageList.map((pageName, index) => {
              return (this._renderButton(pageName, index))
            })
          }

          <div style={{float: "right"}}>
            <Button text="Logout" that={this} onClick={this._onLogoutButtonClick}/>
          </div>
        </div>
        {this.props.children}
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/pages/Index.js